// extracted by mini-css-extract-plugin
export default {"promotions-holder":"Promotions_promotions-holder__d4nVO","image-banner":"Promotions_image-banner__U5JxO","heading-holder":"Promotions_heading-holder__68gcE"};